module.exports = __webpack_public_path__ + "static/map-6a773f3f8c99e66b29832685db9e4130.png";